import $ from 'jquery';
import { getWidth, onResize } from '../utils/window';

export default function cardSection() {
	const $html = $('html');
    // const $scroller = $('html, body');
    const cards = $('.card.-style-over');

    $(function(){
        if(getWidth() > 1080) {
            setTimeout(function(){
                cards.each(function(e){
                    const _this = this;
            
                    $(_this).find('.card_content_body').attr('data-height', $(_this).find('.card_content_body').innerHeight());
                    $(_this).find('.card_content_body').css('height', 0);
            
                    $(_this).mouseenter(function(){
                        // on hover
                        $(_this).find('.card_content_body').animate({
                            height: $(_this).find('.card_content_body').attr('data-height'),
                        }, 300);
                    });
        
                    $(_this).mouseleave(function(){
                        $(_this).find('.card_content_body').animate({
                            height: 0,
                        }, 300);
                    });
                    
                });
            }, 100);
        }
    })
}



// WEBPACK FOOTER //
// ./source/scripts/sections/card.js